/**
 * Модель ключей для отправки на бек
 * @type LabFormData
 */
export const DEFAULT_FORM_FIELDS = {
    FOR_WHO: '', // id для кого
    IS_MAIN: false, // выбрана ли лаборатория главной по умолчанию (1)
    COOKING_TYPE: '', // id названия лаборатории
    EQUIPMENT: {},

    save: 'Save',
};

export const MODAL_SELECTOR = '#lab-modal';
export const ACTION_ADD = 'add';
export const ACTION_EDIT = 'edit';

export const LAB_REDIRECT_URL = 'labRedirectUrl';

export const LOCAL_STORAGE_LAB_ID = 'labFromOrderId';
export const LAB_SAVE_URL = '/personal/lab/';
